module.exports = __webpack_public_path__ + "img/approvalSel.aa96f8b7.svg";